import { OrganisationMapping } from "./CommonUtils/constants";
// import { logEvent } from "firebase/analytics";
// import { analytics } from "../config/firebaseConfig";

const biharIds = new Set(["bihar_pilot_1", "bihar_demo_1", "bihar_pilot_2"]);
const biharPrathamIds = new Set([...biharIds, "pratham_demo_1"]);
const biharPrathamDelhiIds = new Set([...biharPrathamIds, "delhi_mcd_1"]);
const biharPrathamRajIds = new Set([...biharPrathamIds, "bcg_rajasthan_1"]);
const biharPrathamDelhiRajIsakshamIds = new Set([
  ...biharPrathamDelhiIds,
  "bcg_rajasthan_1",
  "isaksham_pilot_2",
]);

export const getTeacherId = (organisation, teacherId) => {
  if (biharIds.has(organisation)) {
    return "teacher_bihar_demo";
  }
  if (organisation === "demo" || organisation === "generic_demo") {
    return "teacher_generic_demo";
  }
  if (organisation === "pratham_demo_1") {
    return "teacher_pratham_demo";
  }
  if (organisation === "delhi_mcd_1") {
    return "teacher_delhi_mcd_1";
  }
  if (organisation === "isaksham_pilot_2") {
    return "teacher_isaksham_pilot_2";
  }
  if (organisation === "bcg_rajasthan_1") {
    return teacherId;
  }
  return "teacher_generic_demo";
};

export const getOrganisationId = (organisation) =>
  OrganisationMapping[organisation] || "generic_demo";

export const getDeviceId = (organisation) => {
  if (biharIds.has(organisation)) {
    return "device_bihar_demo";
  }
  if (organisation === "pratham_demo_1") {
    return "device_pratham_demo";
  }
  if (organisation === "delhi_mcd_1") {
    return "device_delhi_mcd_1";
  }
  if (organisation === "bcg_rajasthan_1") {
    return "device_bcg_rajasthan_1";
  }
  if (organisation === "demo" || organisation === "generic_demo") {
    return "device_generic_demo";
  }
  if (organisation === "isaksham_pilot_2") {
    return "device_isaksham_pilot_2";
  }
  return "device_generic_demo";
};

const getOptions = (start, end) => {
  const options = [];
  for (let i = start; i <= end; i += 1) {
    options.push({
      value: i.toString(),
      label: i.toString(),
    });
  }
  return options;
};

export const getClassNumOptions = (organisation) => {
  if (
    biharPrathamRajIds.has(organisation) ||
    organisation === "isaksham_pilot_2"
  ) {
    return getOptions(1, 8);
  }
  if (organisation === "delhi_mcd_1") {
    return getOptions(2, 5);
  }
  return getOptions(3, 3);
};

export const getNameLabel = (organisation, t) => {
  if (organisation === "pratham_demo_1") {
    return t("child_name_or_id");
  } else if (organisation === "bcg_rajasthan_1") {
    return t("select_child");
  }
  return t("name");
};

export const getGradeLabel = (organisation, t) => {
  if (biharPrathamRajIds.has(organisation)) {
    return t("class");
  }
  if (organisation === "delhi_mcd_1" || organisation === "isaksham_pilot_2") {
    return t("grade");
  }
  return t("grade_for_assessment");
};

export const getSchoolIdLabel = (organisation, t) => {
  if (biharPrathamDelhiIds.has(organisation)) {
    return t("school_id");
  } else if (organisation === "bcg_rajasthan_1") {
    return t("select_school");
  }
  return t("my_institution_is");
};

export const getGrade = (organisation, grade) => {
  if (biharPrathamDelhiRajIsakshamIds.has(organisation)) {
    return grade;
  }
  return 3;
};

export const getTextFieldType = (organisation) => {
  if (biharPrathamIds.has(organisation)) {
    return "number";
  }
  return "text";
};

export const getClassSectionOptions = (organisation) => {
  if (organisation === "delhi_mcd_1" || organisation === "bcg_rajasthan_1") {
    return [
      { value: "A", label: "A" },
      { value: "B", label: "B" },
      { value: "C", label: "C" },
      { value: "D", label: "D" },
      { value: "E", label: "E" },
      { value: "F", label: "F" },
      { value: "G", label: "G" },
    ];
  }
  return [];
};

export const getGenderOptions = (organisation, t) => {
  if (organisation === "delhi_mcd_1" || organisation === "isaksham_pilot_2") {
    return [
      {
        value: "male",
        label: t("boy"),
      },
      {
        value: "female",
        label: t("girl"),
      },
    ];
  }
  return [
    {
      value: "male",
      label: t("male"),
    },
    {
      value: "female",
      label: t("female"),
    },
  ];
};

export const getTeacherLabel = (organisation, t) => {
  if (organisation === "pratham_demo_1") {
    return t("instructor_name");
  } else if (organisation === "bcg_rajasthan_1") {
    return t("select_teacher");
  } else if (organisation === "isaksham_pilot_2") {
    return t("data_collector_name");
  }
  return t("teacher_name");
};

export function getDayFromDate(date, format) {
  return new Date(date).toLocaleDateString("en-GB", {
    day: format,
  });
}

export function getMonthFromDate(date, format) {
  return new Date(date).toLocaleDateString("en-GB", { month: format });
}

export const getFirstNameAndTruncate = (name) => {
  const firstName = name.split(" ")[0];
  if (firstName.length > 20) {
    return `${firstName.substring(0, 20)}...`;
  }
  return firstName;
};

export const getCreateAssessmentRequestBody = (
  urlParams,
  lat = null,
  long = null
) => ({
  student_id: urlParams?.studentId,
  teacher_id: urlParams?.teacherId,
  lang: "hi",
  grade: urlParams?.classNum,
  organisation_id: urlParams?.organisation,
  device_id: `${urlParams?.organisation}_device_id`,
  school_id: urlParams?.schoolId || 1,
  lat: lat,
  long: long,
  student_grade: urlParams?.classNum,
  self_audio_validation: "1",
  student_name: urlParams?.studentName,
  section: urlParams?.section,
  subject_id: urlParams?.subjectId,
  external_assessment_id: urlParams?.externalAssessmentId,
  assessment_type: "primary",
});

export function produceEventLog(eventName, eventProperties = {}) {
  try {
    // logEvent(analytics, eventName, eventProperties);
  } catch (error) {
    console.error(`🚨 Failed to log event: ${eventName}`, error);
  }
}

export function getNetworkType() {
  const connection =
    navigator.connection ||
    navigator.mozConnection ||
    navigator.webkitConnection;

  if (connection && connection.effectiveType) {
    return connection.effectiveType;
  }

  return "unknown"; // Fallback if API isn't supported
}

export const getUserProperties = (useParamValues) => {
  const { organisation, subjectId, classNum, section, schoolId } =
    useParamValues;
  const networkType = getNetworkType();
  return {
    organisation,
    subject_id: subjectId,
    class: classNum,
    section,
    school_id: schoolId,
    network_type: networkType,
  };
};

export const getCurrentDate = () => {
  const date = new Date();
  return `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}/${date.getFullYear()}`;
};

export const getPaginatedCohortPages = (
  students,
  FIRST_PAGE_SIZE,
  REST_PAGE_SIZE
) => {
  const cohorts = { 1: [], 2: [], 3: [], 4: [] };

  // Step 1: Group students by cohort
  students.forEach((student) => {
    cohorts[student.cohort].push(student);
  });

  // Step 2: Paginate each cohort with dynamic first/next page size
  const chunkedCohorts = {};

  for (let c = 1; c <= 4; c++) {
    chunkedCohorts[c] = [];
    const students = cohorts[c];

    if (students.length === 0) continue;

    // First page
    chunkedCohorts[c].push(students.slice(0, FIRST_PAGE_SIZE));

    // Remaining pages
    for (let i = FIRST_PAGE_SIZE; i < students.length; i += REST_PAGE_SIZE) {
      chunkedCohorts[c].push(students.slice(i, i + REST_PAGE_SIZE));
    }
  }

  // Step 3: Combine cohorts into page-wise structure
  const totalPages = Math.max(
    ...Object.values(chunkedCohorts).map((p) => p.length)
  );

  const paginatedPages = [];
  for (let i = 0; i < totalPages; i++) {
    const page = {};
    for (let c = 1; c <= 4; c++) {
      page[c] = chunkedCohorts[c][i] || [];
    }
    paginatedPages.push(page);
  }

  return paginatedPages;
};

export const formatCorrectPercentage = (percentage, toFixed = 0) =>
  percentage ? (percentage * 100).toFixed(toFixed) : 0;
